// assets/cart-jewellery-box.js

document.addEventListener('DOMContentLoaded', function() {
    let cartConfig = JSON.parse(localStorage.getItem('cartConfig') || '{}');
    // console.log('CartConfig:', cartConfig);
    let selectedBoxes = JSON.parse(sessionStorage.getItem('jewellery_box_types') || '[]');
    
    function handleBoxClick(e) {
        const button = e.currentTarget;
        const description = button.closest('.card').querySelector('[data-box-description]').textContent.trim();
        
        if (!button.classList.contains('selected')) {
            selectedBoxes.push(description);
            button.classList.add('selected');
            button.textContent = 'Selected';
        } else {
            selectedBoxes = selectedBoxes.filter(box => box !== description);
            button.classList.remove('selected');
            button.textContent = 'Select';
        }
        
        sessionStorage.setItem('jewellery_box_types', JSON.stringify(selectedBoxes));
        updateCartAttributes();
    }

    function initializeBoxes() {
        document.querySelectorAll('[data-box-select]').forEach(button => {
            if (button.hasAttribute('data-add-to-cart')) return;
            
            const description = button.closest('.card')
                ?.querySelector('[data-box-description]')
                ?.textContent?.trim();
            
            if (!description) return;

            // Remove old listener and add new one
            const newButton = button.cloneNode(true);
            button.parentNode.replaceChild(newButton, button);
            
            if (selectedBoxes.includes(description)) {
                newButton.classList.add('selected');
                newButton.textContent = 'Selected';
            }
            
            newButton.addEventListener('click', handleBoxClick);
        });
    }

    window.initializeBoxes = initializeBoxes;

    function updateCartAttributes() {
        fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                attributes: {
                    'Selected Jewellery Boxes': selectedBoxes.join(', ')
                }
            })
        });
    }

    // Initialize on page load
    initializeBoxes();

    // Initialize when cart drawer opens
    document.addEventListener('cart:drawer:opened', initializeBoxes);
});

document.addEventListener('DOMContentLoaded', function() {
  // var windowWidth = window.innerWidth;
  var swiperInstance;
  
  function initSwiper() {
    if (swiperInstance) {
      swiperInstance.destroy(true, true);
    }
    
    swiperInstance = new Swiper('.swiper-container', {
      slidesPerView: 'auto',
      spaceBetween: 20,
      direction: "horizontal",
      grabCursor: true,
      allowTouchMove: true,
      observer: true,
      observeParents: true,
      watchOverflow: true,
      loop: false, 
      resistance: true, 
      resistanceRatio: 0.85,
      speed: 700,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      touchReleaseOnEdges: true,
      followFinger: true,
      cssMode: false,
      on: {
        init: function() {
          checkNavigationVisibility();
        },
        resize: function() {
          this.update();
          checkNavigationVisibility();
        }
      }
    });
  }
  
  function checkNavigationVisibility() {
    const container = document.querySelector('.swiper-container');
    const wrapper = document.querySelector('.swiper-wrapper');
    const prevButton = document.querySelector('.swiper-button-prev');
    const nextButton = document.querySelector('.swiper-button-next');
    
    if (!container || !wrapper || !prevButton || !nextButton) return;
    
    const hasOverflow = wrapper.scrollWidth > container.clientWidth;
    const isAccordionOpen = document.querySelector('a[expand-button].is-active');
    const isMobile = window.innerWidth < 750;
    
    // Special handling for mobile
    if (isMobile && isAccordionOpen) {
      prevButton.style.display = hasOverflow ? 'flex' : 'none';
      nextButton.style.display = hasOverflow ? 'flex' : 'none';
      
      // Force update swiper after accordion opens
      if (swiperInstance) {
        swiperInstance.update();
      }
    } else {
      prevButton.style.display = (hasOverflow && isAccordionOpen) ? 'flex' : 'none';
      nextButton.style.display = (hasOverflow && isAccordionOpen) ? 'flex' : 'none';
    }
  }
  
  function initAccordionListeners() {
    const expandButton = document.querySelector('a[expand-button]');
    if (expandButton) {
      expandButton.addEventListener('click', function(e) {
        e.preventDefault();
        this.classList.toggle('is-active');
        
        // Update navigation visibility immediately
        const isOpen = this.classList.contains('is-active');
        const prevButton = document.querySelector('.swiper-button-prev');
        const nextButton = document.querySelector('.swiper-button-next');
        
        if (prevButton && nextButton) {
          if (!isOpen) {
            prevButton.style.display = 'none';
            nextButton.style.display = 'none';
          } else {
            // Short delay to let the accordion animation start
            setTimeout(() => {
              if (swiperInstance) {
                swiperInstance.update();
                swiperInstance.setTranslate(swiperInstance.getTranslate());
                checkNavigationVisibility();
              }
            }, 500);
          }
        }
      });
    }
  }

  window.addEventListener('load', function() {
    initSwiper();
    initAccordionListeners();
    
    window.addEventListener('resize', function() {
      if (swiperInstance) {
        swiperInstance.update();
        checkNavigationVisibility();
      }
    });
  });
  
  
});